import React, { lazy } from 'react'
import { navCollectionsRetailerRoutingConfig } from 'domains/collections/utils/navCollectionsRoutingConfig'
import { NavCollectionsListPage } from 'domains/collections/pages/retailer/NavCollectionsListPage'
import { NavCollectionsViewPage } from 'domains/collections/pages/retailer/NavCollectionsViewPage'
import { DomainRoute } from 'domains/collections/utils/domain/routingComponents'
import { navCollectionsAccessControl } from 'domains/collections/access-control/navCollectionsAccess.configuration'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'

export const navCollectionsRouter = (
  <DomainRoute route="retailer-nav-collections" accessControl={navCollectionsAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route={navCollectionsRetailerRoutingConfig.list}
        component={NavCollectionsListPage}
      />
      <DomainRoute
        exact
        route={navCollectionsRetailerRoutingConfig.show}
        component={NavCollectionsViewPage}
      />
    </DashSwitch>
  </DomainRoute>
)
